module.exports = __webpack_public_path__ + "img/black-truffle1.c7901212.png";